<template>
  <div class="myhome">
    <div class="top">
      <div class="left">
        <div><img class="headIcon" src="./images/ic_head.png" alt="" /></div>
        <div>
          <ul>
            <li>
              <span><img src="./images/ic_accont.png" alt=""/></span>
              <span>{{ $tc('lang.myHome.Chinses_Package_Balance') }}</span>
              <span
                >{{ chineseBalance }}{{ $tc('lang.myHome.Balance_Unit') }}</span
              >
            </li>
            <li>
              <span><img src="./images/ic_pay.png" alt=""/></span>
              <span>{{ $tc('lang.myHome.English_Package_Balance') }}</span>
              <span
                >{{ englishBalance }}{{ $tc('lang.myHome.Balance_Unit') }}</span
              >
            </li>
            <li>
              <span><img src="./images/ic_name.png" alt=""/></span>
              <span>{{ $tc('lang.myHome.Available_Coupons') }}</span>
              <span class="couponsValue"
                >{{ coupons }}{{ $tc('lang.myHome.Zhang') }}
              </span>
            </li>
          </ul>
        </div>
        <div>
          <router-link to="/mySetMeal">
            <button class="buybtn">{{ $tc('lang.myHome.Buy_Package') }}</button>
          </router-link>
        </div>
      </div>
      <div class="right">
        <div>
          {{ $tc('lang.myHome.now') }}<br />{{ $tc('lang.myHome.order') }}
        </div>
        <div>
          <router-link to="/factory">
            <span>
              <img src="./images/yc.png" />
              <strong>{{ $tc('lang.myHome.Factory') }}</strong>
            </span>
          </router-link>
          <router-link to="/goods">
            <span class="margin0">
              <img src="./images/yh.png" />
              <strong>{{ $tc('lang.myHome.Product') }}</strong>
            </span>
          </router-link>
          <router-link to="/supervision">
            <span class="marginBottom0">
              <img src="./images/jz.png" />
              <strong>{{ $tc('lang.myHome.Supervision') }}</strong>
            </span>
          </router-link>
          <router-link to="/goods/end">
            <span class="margin0 marginBottom0">
              <img src="./images/ml.png" />
              <strong>{{ $tc('lang.myHome.Fabric') }}</strong>
            </span>
          </router-link>
          <!--<router-link to="/goods"
            ><span class="yh">{{
              $tc('lang.myHome.Product')
            }}</span></router-link
          >
          <router-link to="/supervision"
            ><span class="jz">{{
              $tc('lang.myHome.Supervision')
            }}</span></router-link
          >
          <router-link to="/goods/end"
            ><span class="ml">{{
              $tc('lang.myHome.Fabric')
            }}</span></router-link
          >-->
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="left">
        <div class="icon"><img src="./images/order.png" alt="" /></div>
        <div class="sum">
          <div>
            <p class="total">{{ orderTotal }}</p>
            <p>{{ $tc('lang.myHome.Order_List') }}</p>
          </div>
        </div>
      </div>
      <div class="right">
        <a-spin :spinning="loading" tip="Loading...">
          <ul>
            <li v-for="record in orderData" :key="record.id">
              <span class="span1">{{ $tc('lang.orderAll.Order_Number') }}</span>
              <span>{{ record.orderId }}</span>
              <span>{{ $tc('lang.orderAll.Vendor_name') }}</span>
              <span>{{ record.orderFactoryname }}</span>
              <span>{{ $tc('lang.orderAll.Service_Date') }}</span>
              <span>{{ $momentData(record.orderServicedate) }}</span>
              <span>
                <!--支付  0/1-->
                <a-button
                  type="primary"
                  class="pay"
                  @click.stop="action(record, 2)"
                  v-if="record.orderState === '1' || record.orderState === '0'"
                  :disabled="
                    record.orderState !== '1' ||
                      record.orderServicechargeusd === null ||
                      record.orderServicechargermb === null
                  "
                >
                  {{ $tc('lang.myHome.Pay') }}
                </a-button>
                <!--查看  <=8  -->
                <a-button
                  class="pay"
                  type="primary"
                  @click.stop="queryReportList(record)"
                  v-if="
                    record.orderState <= 8 &&
                      record.orderState !== '0' &&
                      record.orderState !== '1'
                  "
                >
                  {{ $tc('lang.myHome.View') }}
                </a-button>
                <!--编辑  ==10  -->
                <a-button
                  type="primary"
                  class="pay"
                  @click.stop="queryReportList(record)"
                  v-if="record.orderState == '10'"
                >
                  {{ $tc('lang.myHome.Edit') }}
                </a-button>
                <!--恢复   >10  -->
                <a-popconfirm
                  :title="$tc('lang.myHome.RECOVER_Order')"
                  okText="Confirm"
                  cancelText="Cancel"
                  v-if="record.orderState > 10"
                  @confirm="action(record, 3)"
                  @cancel="cancelButton()"
                >
                  <a-button type="primary" class="pay" @click.stop>
                    {{ $tc('lang.myHome.Recover') }}
                  </a-button>
                </a-popconfirm>
                <!--取消  <=10   -->
                <a-popconfirm
                  :title="$tc('lang.myHome.CANCEL_order')"
                  okText="Confirm"
                  cancelText="Cancel"
                  v-if="record.orderState <= 10"
                  @confirm="onOrderState(record, 5)"
                  @cancel="cancelButton()"
                >
                  <a-button class="cancel" @click.stop>
                    {{ $tc('lang.myHome.Cancel') }}
                  </a-button>
                </a-popconfirm>

                <!--删除-->
                <a-popconfirm
                  :title="$tc('lang.myHome.DELETE_Order')"
                  okText="Confirm"
                  cancelText="Cancel"
                  v-if="record.orderState > 10"
                  @confirm="onOrderState(record, 4)"
                  @cancel="cancelButton()"
                >
                  <a-button
                    class="cancel"
                    @click.stop
                    v-if="record.orderState > 10"
                  >
                    {{ $tc('lang.myHome.Delete') }}
                  </a-button>
                </a-popconfirm>
              </span>
            </li>
          </ul>
        </a-spin>
        <div class="more">
          <router-link to="/allorder">{{
            $tc('lang.myHome.More')
          }}</router-link>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="icon"><img src="./images/report.png" alt="" /></div>
        <div class="sum">
          <div>
            <p class="total">{{ reportTotal }}</p>
            <p>{{ $tc('lang.myHome.Report_Overview') }}</p>
          </div>
        </div>
      </div>
      <div class="right">
        <a-spin :spinning="loading2" tip="Loading...">
          <ul>
            <li v-for="record in reportData" :key="record.id">
              <span class="span1">{{ $tc('lang.Reports.Report_Nr') }}</span>
              <span>{{ record.reportNo }}</span>
              <span>{{ $tc('lang.Reports.Factory') }}</span>
              <span>{{ record.factoryName }}</span>
              <span>{{ $tc('lang.Reports.Report_Date') }}</span>
              <span>{{ $momentData(record.planTime) }}</span>
              <span>
                <a-button class="pay" @click="lookReport()">
                  {{ $tc('lang.orderAll.View') }}
                </a-button>
                <a-button
                  class="cancel"
                  size="small"
                  @click="downloadReport(record)"
                  :disabled="record.pdfPath === null"
                >
                  {{ $tc('lang.myHome.Download') }}
                </a-button>
              </span>
            </li>
          </ul>
        </a-spin>
        <div class="more">
          <router-link to="/reportManage">{{
            $tc('lang.myHome.More')
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'home',
  data() {
    return {
      chineseBalance: 0,
      englishBalance: 0,
      coupons: 0,
      orderData: [],
      reportData: [],
      orderTotal: 0,
      reportTotal: 0,
      // 数据加载状态
      loading: false,
      loading2: false,
      loadingCen: false,
      loadingInit: false,
      loadingDe: false,
    };
  },
  created() {
    this.queryReport();
    this.queryOrder();
    this.getPackageBalance();
    this.getCoupons();
  },
  methods: {
    //获取套餐余额
    getPackageBalance() {
      const userData = JSON.parse(sessionStorage.getItem('user')) || {};
      const personId = userData.id;
      this.$http
        .get(`/hzwmj/person-setmealpay/getSetmealCount?personId=${personId}`)
        .then(data => {
          if (data.code === 200) {
            const packageBalance = data.data;
            this.chineseBalance = packageBalance.countCN;
            this.englishBalance = packageBalance.countEN;
          }
        })
        .catch(() => {
          this.chineseBalance = 0;
          this.englishBalance = 0;
        });
    },
    //获取代金券数量
    getCoupons() {
      const userData = JSON.parse(sessionStorage.getItem('user')) || {};
      const personId = userData.id;
      this.$http
        .post(`/hzwmj/person-coupon/getCoupon`, {
          personId: personId,
        })
        .then(data => {
          if (data.code === 200) {
            const couponsData = data.data.unused;
            this.coupons = couponsData.length;
          }
        })
        .catch(() => {
          this.coupons = 0;
        });
    },
    // 获取订单表格请求
    queryOrder() {
      this.loading = true;
      // 获取用户sessionStorage信息
      const userData = JSON.parse(sessionStorage.getItem('user')) || {};
      this.$http
        .post('/hzwmj/workorder/getOrderPageList', {
          page: 1,
          size: 3,
          personId: userData.id,
        })
        .then(data => {
          if (data.code === 200) {
            const buyData = data.data;
            console.log('=====orderData====', buyData);
            this.orderData = buyData.records;
            this.orderTotal = buyData.total;
            this.loading = false;
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {
          this.orderData = [];
          this.total = 0;
          this.loading = false;
        });
    },
    // 获取报告列表信息
    queryReport() {
      this.loading2 = true;
      const userData = JSON.parse(sessionStorage.getItem('user')) || {};
      this.$http
        .post('/hzwmj/workorder-inspectreport/getPageList', {
          page: 1,
          size: 3,
          personId: userData.id,
        })
        .then(data => {
          if (data != null) {
            const reastData = data.data;
            console.log('=====reportData====', reastData);
            this.reportData = reastData.records;
            this.reportTotal = reastData.total;
            this.loading2 = false;
          } else {
            this.reportData = [];
            this.reportTotal = 0;
            this.loading2 = false;
          }
        })
        .catch(() => {
          this.reportData = [];
          this.reportTotal = 0;
          this.loading2 = false;
        });
    },
    // 查看报告
    lookReport() {
      this.$router.push({
        path: '/reportManage',
        /*query: {
          id: record.id,
        },*/
      });
      //console.log('recodr:', record);
    },
    // 报告下载
    downloadReport(record) {
      // record.pdfPath
      const hide = this.$message.loading('报告生成中...', 0);
      setTimeout(hide, 0);
      let aLink = document.createElement('a');
      document.body.appendChild(aLink);
      aLink.href = this.config.urlImg + record.pdfPath;
      // aLink.href =  record.pdfPath;
      aLink.click();
      // this.$http
      //   .get('/hzwmj/workorder-inspectreport/creatReport', {
      //     params: {
      //       orderId: record.orderNo,
      //       reportId: record.reportNo,
      //     },
      //   })
      //   .then(data => {
      //     if (data) {
      //       setTimeout(hide, 0);
      //       let aLink = document.createElement('a');
      //       document.body.appendChild(aLink);
      //       aLink.href = this.config.urlImg + data;
      //       aLink.click();
      //       aLink.remove();
      //     } else {
      //       setTimeout(hide, 0);
      //       this.$message.error('生成失败');
      //     }
      //   })
      //   .catch(() => {
      //     setTimeout(hide, 0);
      //     this.$message.error('生成失败');
      //   });
    },
    /*查看报告编号*/
    queryReportList(value) {
      // this.add()
      console.log(`Report ${value}`);
      console.log('Report', value);
      this.$router.push({
        path: '/allorder',
        /*query: {
          id: value.orderId,
        },*/
      });
    },
    // 取消修改订单状态
    cancelButton() {
      this.queryOrder();
    },
    //立即支付
    action(record, e) {
      // 1-立即编辑，2-立即支付,3-恢复
      console.log(record);
      if (e === 1) {
        this.$router.push({
          path: '/goods',
          query: {
            id: record.id,
            orderId: record.orderId,
            type: 2,
          },
        });
      }
      if (e === 2) {
        this.$router.push({
          path: '/pay',
          query: {
            id: record.id,
            type: 2,
          },
        });
      }
      if (e === 3) {
        this.loadingInit = true;
        this.$http
          .post('/hzwmj/workorder/updateStatus', {
            orderNo: record.orderId,
            status: '10',
          })
          .then(data => {
            if (data.code === 200) {
              const buyData = data.data;
              if (buyData === true) {
                this.loadingInit = false;
                console.log('========', buyData);
                // this.$router.push('/allorder');
                this.queryOrder();
              }
            } else if (data.code === 900) {
              this.$message.error(data.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch(() => {
            this.data = [];
            this.total = 0;
            this.loadingInit = false;
          });
      }
    },
    // 修改订单状态
    onOrderState(record, e) {
      // 4-删除订单,5-取消订单
      console.log('===del=', e);
      if (e === 5) {
        this.loadingCen = true;
        this.$http
          .post('/hzwmj/workorder/updateStatus', {
            orderNo: record.orderId,
            status: '11',
          })
          .then(data => {
            if (data.code === 200) {
              const buyData = data.data;
              if (buyData === true) {
                this.loadingCen = false;
                // this.$router.push('/allorder');
                this.queryOrder();
              }
            } else if (data.code === 900) {
              this.$message.error(data.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch(() => {
            this.data = [];
            this.total = 0;
            this.loadingCen = false;
          });
      } else {
        this.loadingDe = true;
        this.$http
          .get('/hzwmj/workorder/delete', {
            params: {
              id: record.id,
            },
          })
          .then(data => {
            if (data.code === 200) {
              const buyData = data.data;
              if (buyData === true) {
                this.loadingDe = false;
                this.queryOrder();
              }
            } else if (data.code === 900) {
              this.$message.error(data.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch(() => {
            this.data = [];
            this.total = 0;
            this.loadingDe = false;
          });
      }
    },
  },
};
</script>
<style lang="less">
.content2 {
  .myhome {
    background: #f0f2f5;
  }
  img {
    width: 100%;
  }
  span {
    display: inline-block;
  }
  button {
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  button[disabled] {
    cursor: not-allowed;
  }
  .left,
  .right {
    background: #fff;
    float: left;
  }
  //height: 100vh-152px (64+48+40)px  4:3:3   (10vh-15.2px)  40vh-52.8px : 30vh-39.6px :30vh-39.6px
  .top {
    //margin-bottom: 20px;  60vh-79.2-20
    height: calc(40vh - 62.8px);
    margin-bottom: 20px;
    overflow: hidden;
    .left,
    .right {
      height: calc(40vh - 62.8px);
      width: calc(50% - 10px);
      border-radius: 5px;
    }
    .left {
      background: #fff !important;
      margin-right: 20px;
      overflow: hidden;

      div {
        float: left;
        width: 30%;
        margin: 0 auto;
        height: 100%;
        position: relative;
      }
      div:nth-child(1) .headIcon {
        width: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      div:nth-child(2) {
        width: 43%;
        ul {
          text-align: left;
          margin-left: -6%;
          padding-left: 0 !important;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(0, -50%);
          li {
            font-size: 14px;
            line-height: 30px;
            span:nth-child(1) {
              width: 13px;
              height: 13px;
              display: inline-block;
              margin-right: 5px;
            }

            span:nth-child(2) {
              color: #999;
              display: inline-block;
              margin-right: 8px;
            }

            span:nth-child(3) {
              color: #3f94fd;
            }
            .couponsValue {
              text-decoration: underline;
              margin-left: 15px;
            }
          }
        }
      }
      div:nth-child(3) {
        width: 27%;
        text-align: left;
        .buybtn {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          padding: 6px 25px;
          font-size: 14px;
          color: #fff;
          background-image: linear-gradient(to right, #2ebeff, #3f94fd);
        }
      }
    }
    .right {
      padding: 10px;
      box-sizing: border-box;
      position: relative;
      height: 100%;
      div {
        float: left;
      }
      div:nth-child(1) {
        width: 25%;

        padding: calc(20vh - 71.4px) 0;
        line-height: 30px;
        border-right: 1px solid #eee;
        font-size: 20px;
        color: #6e6e6e;
      }
      div:nth-child(2) {
        width: 73%;
        padding-left: 10px;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translate(0, -50%);
        span {
          width: calc(50% - 10px);
          color: #fff;
          margin-bottom: 10px;
          position: relative;
          img {
            width: 100%;
          }
          strong {
            position: absolute;
            top: 50%;
            right: 18px;
            transform: translate(0, -50%);
            font-size: 18px;
          }
        }
        .margin0 {
          margin-left: 10px;
        }
        .marginBottom0 {
          margin-bottom: 0;
        }
      }
    }
  }
  .middle,
  .bottom {
    height: calc(30vh - 45.6px);
    overflow: hidden;
    width: 100%;
    .left,
    .right {
      height: calc(30vh - 45.6px);
      border-radius: 5px;
      background: #fff !important;
    }
    .left {
      width: calc(20% - 20px);
      margin-right: 20px;
      div {
        float: left;
      }
      .icon {
        width: 50%;
        height: 100%;
        position: relative;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 40%;
        }
      }
      .sum {
        width: 50%;
        height: 100%;
        position: relative;
        div {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(0, -50%);
          p {
            font-size: 16px;
            text-align: left;
            margin-bottom: 0;
            color: #6e6e6e;
            line-height: 32px;
          }
          .total {
            color: #6e6e6e;
            font-size: 20px;
            font-weight: 600;
            line-height: 35px;
          }
        }
      }
    }
    .right {
      position: relative;
      width: 80%;
      overflow: hidden;
      ul {
        padding: 19.5px;
        padding-right: 0;
        margin-bottom: 0;
        width: 90%;
        float: left;
        li {
          color: #6d6d6d;
          font-size: 14px;
          position: relative;
          /*width: 90%;*/
          border-bottom: 1px solid #f4f3f3;
          list-style: none;
          text-align: left;
          height: calc(10vh - 15.2px - 13px);
          line-height: calc(10vh - 15.2px - 13px);
          //height:calc( 16.6vh-66px );
          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .span1 {
            width: 8%;
          }
          span:nth-child(2) {
            width: 22%;
          }
          span:nth-child(3) {
            width: 8%;
          }
          span:nth-child(4) {
            width: 22%;
          }
          span:nth-child(5) {
            width: 10%;
          }
          span:nth-child(6) {
            width: 15%;
          }
          span:nth-child(7) {
            position: absolute;
            right: 5px;
            padding-top: calc(5vh - 7.6px - 20px);
            .pay,
            .cancel {
              padding: 0 12px;
              color: #fff;
              height: 27px;
              line-height: 27px;
              background-color: #4f96fe;
            }
            .cancel {
              background-color: #80d0fc;
              margin-left: 10px;
            }
          }
        }
        li:last-child {
          border-bottom: none;
        }
      }
      .more {
        float: right;
        width: 10%;
        height: calc(30vh - 45.6px);
        line-height: calc(30vh - 45.6px);
        text-align: center;
        font-size: 16px;
        a {
          color: #4f96fe !important;
        }
      }
    }
  }
  .middle {
    margin-bottom: 20px;
  }
}
</style>
